module.exports = __webpack_public_path__ + "img/Policier_02_TPA.4dc56dac.jpg";